import React, { FC, useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PostsGridContent } from '../PostsGridContent/PostsGridContent';
import { usePostDiscovery, UsePostsCollectionProps } from '../usePostDiscovery';
import { PER_PAGE } from './constants';
import { DiscoveryPostsGridProps } from './types';

export const DiscoveryPostsGrid: FC<DiscoveryPostsGridProps> = ({
    postId,
    dialogName,
    ...props
}) => {
    const [query] = useSearchParams();
    const lastParamsRef = useRef<UsePostsCollectionProps>();

    const discoveryParams = useMemo(() => {
        if (dialogName && lastParamsRef.current) {
            return lastParamsRef.current;
        }

        let requestParams: UsePostsCollectionProps = {
            namespace: 'discovery-page-collection',
            filters: {
                amount: PER_PAGE,
                collectionId: undefined,
                businessId: undefined,
                isDefaultDiscovery: true,
                first_post_id: query.get('first_post_id'),
            },
            forceFiltersUpdate: true,
        };

        if (postId) {
            requestParams = {
                namespace: `search-collection-${postId}`,
                filters: {
                    amount: PER_PAGE,
                    collectionId: undefined,
                    businessId: undefined,
                    postIdForDiscovery: postId,
                },
                forceFiltersUpdate: true,
            };
        }

        lastParamsRef.current = requestParams;

        return requestParams;
    }, [postId, dialogName, query]);

    const collection = usePostDiscovery(discoveryParams);

    return (
        <PostsGridContent collection={collection} keyPrefix={`discovery-${postId}`} {...props} />
    );
};
